var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero"},[_c('div',{staticClass:"hero--content",style:(("background-image:url(" + _vm.heroBackground + ")"))})])}
var staticRenderFns = []

export { render, staticRenderFns }